import {
  PUSH_AD,
  UPDATE_ADS_LAST_REFRESH_TIME
} from '../../actions/actionTypes'

const defaultState = {
  displayedAds: []
}

const ads = (state = defaultState, action) => {
  switch (action.type) {
    case PUSH_AD:
      return Object.assign({}, state, {
        displayedAds: [...state.displayedAds, action.ad],
        adsLastRefreshedAt: new Date()
      })
    case UPDATE_ADS_LAST_REFRESH_TIME:
      return Object.assign({}, state, {
        adsLastRefreshedAt: new Date()
      })
    default:
      return state
  }
}

export { ads }
